import React from "react";
import styles from "./SocialLinks.module.css";
import { ReactComponent as MailIcon } from "../assets/icons/mail.svg";
import { ReactComponent as LinkedinIcon } from "../assets/icons/linkedin.svg";
import { ReactComponent as ArtstationIcon } from "../assets/icons/artstation.svg";
import { useSound } from "../context/SoundContext";

const SocialLinks = () => {
  const { playClick } = useSound();
  
  return (
    <div className={styles.socialLinks}>
      <a
        href="mailto:kadirsbingoel@gmail.com"
        className={styles.socialLink}
        onClick={playClick}
      >
        <MailIcon className={styles.icon} />
      </a>
      <a
        href="https://linkedin.com"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.socialLink}
        onClick={playClick}
      >
        <LinkedinIcon className={styles.icon} />
      </a>
      <a
        href="https://artstation.com"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.socialLink}
        onClick={playClick}
      >
        <ArtstationIcon className={styles.icon} />
      </a>
    </div>
  );
};

export default SocialLinks;
